import React, { Component } from "react";
import MailGunConfigurationTabs from "../AuthorizedSenders/MailGunConfigurationTabs";
import mailGunEmailActions from "../../../store/mailgunEmails/action";
import { connect } from "react-redux";
import chistory from "../../Shared/history";
import MG_DeleteAllAuthSenders from "../ModalPopups/MG_DeleteAllAuthSenders";
import EmailConfigTabs from "../Enums/EmailConfigTabs";
import MailGunEmailTypes from "../Enums/MailGunEmailTypes";
import MG_DeleteEmailList from "../ModalPopups/MG_DeleteEmailList";
import EmailService from "../EmailListService";
import $ from "jquery";
import { toast } from "react-toastify";
import AuthService from "../../Auth/AuthService";
import * as Permissions from "../../Permissions/PermissionValues";

//NEW Component Opened from Email List view icon click.....
class ConfiureMG_Email extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteEmailListModal: false,
      emailListDetails: {},
      currentEmailConfigTab: "",
      // postDomain: "",
    };

    this.confirmEmailList = () => {
      this.confirmed = async () => {
        let { emailListId, emailEntityType } = this.props.melstate;
        let deleteResponse = null;
        if (emailEntityType == MailGunEmailTypes.Member) {
          await EmailService.DeleteSSEmailList(emailListId).then(
            ({ data: response }) => {
              $(".loading").hide();
              if (response.status === "success") {
                toast.success("Email list removed successfully!");
                deleteResponse = 1;
                $(".loading").hide();
              } else {
                toast.error(response.message);
                deleteResponse = 0;
                $(".loading").hide();
              }
            }
          );
        } else if (emailEntityType !== MailGunEmailTypes.Member) {
          await EmailService.DeleteFRTEmailList(emailListId).then(
            ({ data: response }) => {
              $(".loading").hide();
              if (response.status === "success") {
                toast.success("Email list removed successfully!");
                deleteResponse = 1;
                $(".loading").hide();
              } else {
                toast.error(response.message);
                deleteResponse = 0;
                $(".loading").hide();
              }
            }
          );
        }
        this.toggleDeleteEmailListModal();
        if (deleteResponse == 1) {
          this.goBackToEmailList();
        }
      };

      return this;
    };
    this.mailgunConfigurationTabComp = React.createRef();
  }
  toggleDeleteEmailListModal = () => {
    this.setState({
      showDeleteEmailListModal: !this.state.showDeleteEmailListModal,
    });
  };
  componentDidMount = async () => {
    const { id } = this.props.match.params;
    const configTab = this.mailgunConfigurationTabComp.current;

    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.emailListDetails
    ) {
      var emailListDetails = this.props.location.state.emailListDetails;
      this.initializeState(emailListDetails);
      localStorage.setItem(
        "mg_email_List_details",
        JSON.stringify(emailListDetails)
      );
    } else {
      var emailListDetails = JSON.parse(
        localStorage.getItem("mg_email_List_details")
      );
      if (emailListDetails != null) {
        this.initializeState(emailListDetails);
      } else {
        chistory.push("/admin/email-list");
      }
    }
    await this.setState({
      currentEmailConfigTab: EmailConfigTabs.Subscribers,
    });
    let { currentEmailConfigTab } = this.state;
    configTab && (await configTab.setKey(currentEmailConfigTab));
    //console.log("componentDidMount ConfiureMG_Email called.");
  };
  initializeState = async (emailListDetails) => {
    await this.setState({ emailListDetails }, async () => {
      await this.props.setMgListFullAddress(emailListDetails.email_Address);
    });
    let formData = {
      emailListId: emailListDetails.id,
      emailEntityType: emailListDetails.email_List_Type_Id,
      entityKey: emailListDetails.entity_Key,
      mailingListName: emailListDetails.mailingListName || "",
    };
    this.props.resetAuthSenderMembers();
    this.props.resetAddlMembers();
    this.props.getAuthSenders(formData);
    await this.props.setEmailListDetails(formData);
    this.props.setAddtlSubsLoading(true);
    await this.props.reloadAdditionalSubsribersTables();
    this.props.setAddtlSubsLoading(false);
    await EmailService.GetDomainName()
      .then(async ({ data: response }) => {
        if (response.status === "success") {
          //await this.setState({
          //   postDomain: response.postDomain,
          //});
          //console.log(this.state.domain);
          let domainName = response.domain;
          domainName = domainName.replace("@", "");
          await this.props.setMgListDomain(domainName);
          // await this.props.setMgPostListDomain(response.postDomain);
        }
      })
      .catch((ex) => {
        console.log(ex);
        toast.error("Something went wrong!");
      });
  };

  canDeleteEmailList = () => {
    let canDel = AuthService.canDelete(Permissions.Email_Lists);
    return canDel;
  };
  goBackToEmailList = () => {
    chistory.push("/admin/email-list");
    this.props.resetAuthSenderMembers();
    this.props.resetAddlMembers();
    this.props.resetEmailConfigDetails();
  };
  render() {
    let mgListAddress = this.state.emailListDetails
      ? this.state.emailListDetails.email_Address
      : "";
    let mgListTitle = this.state.emailListDetails
      ? this.state.emailListDetails.email_Title
      : "";
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            {mgListAddress && (
              <>
                <MailGunConfigurationTabs
                  mgListAddress={mgListAddress}
                  emailListTitle={mgListTitle}
                  ssUpdateEmailListMode={true} //will always be edit mode
                  emailEntityType={
                    this.state.emailListDetails.email_List_Type_Id
                  }
                  ref={this.mailgunConfigurationTabComp}
                  entityKey={this.state.emailListDetails.entity_Key}
                  emailListExists={true}
                  currentEmailConfigTab={this.state.currentEmailConfigTab}
                  hideActionIcons={EmailService.shouldHideActionIcons()}
                />
                <div className="modal-footer">
                  <div className="row">
                    {EmailService.shouldHideActionIcons() ? (
                      <div className="col-md-4 p-0">
                        <button
                          className="btn btn-success btn-x-sm btn-sm ml-sm-2 ml-1 w-md waves-effect waves-light"
                          type="submit"
                          onClick={() => this.props.saveEmailConfigData()}
                        >
                          Save Changes
                        </button>
                      </div>
                    ) : (
                      <div className="col-md-4 p-0">
                        <button
                          className="btn btn-success btn-x-sm btn-sm ml-sm-2 ml-1 w-md waves-effect waves-light invisible"
                          type="button"
                        >
                          Save Changes
                        </button>
                      </div>
                    )}

                    <div className="col-md-2 pr-0 pl-0">
                      <button
                        className="btn btn-secondary btn-x-sm btn-sm w-md waves-effect waves-light"
                        onClick={this.goBackToEmailList}
                      >
                        Back
                      </button>
                    </div>
                    {EmailService.shouldHideActionIcons() ||
                    this.canDeleteEmailList() === true ? (
                      <div className="col-md-6 pl-1 pr-1 d-flex justify-content-end">
                        <button
                          className="btn btn-danger btn-x-sm btn-sm w-md waves-effect waves-light"
                          type="button"
                          onClick={this.toggleDeleteEmailListModal}
                        >
                          Delete Email List
                        </button>
                      </div>
                    ) : (
                      <div className="col-md-6 pl-1 pr-1 d-flex justify-content-end invisible">
                        <button
                          className="btn btn-danger btn-x-sm btn-sm w-md waves-effect waves-light"
                          type="button"
                        >
                          Delete Email List Inv
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <MG_DeleteEmailList
          modal={this.state.showDeleteEmailListModal}
          confirm={this.confirmEmailList}
          toggle={this.toggleDeleteEmailListModal}
        />
      </div>
    );
  }
}
export default connect(
  (state) => ({
    melstate: state.mailGunEmail,
  }),
  {
    ...mailGunEmailActions,
  }
)(ConfiureMG_Email);
